import LicenseList from './LicenseList';
export default LicenseList;
